/**
 * The admin pages, named once.
 *
 * Four places need to agree on this list — the admin nav, the desktop user
 * menu, the phone menu and the chat widget's blocklist — and they were drifting
 * apart: the overview page was added to three of them and the chat bubble kept
 * appearing on it. Adding a fifth admin page should mean editing this array and
 * nothing else.
 *
 * Names, not paths: names are the stable identifier in routeConfiguration.js.
 */
export const ADMIN_PAGE_NAMES = ['AdminOverviewPage', 'ListingAdminPage', 'BannerAdminPage'];

/**
 * Where a single "Admin" link goes. The overview is the way in; the other
 * pages are reached from the nav along the top of it.
 */
export const ADMIN_LANDING_PAGE = 'AdminOverviewPage';

/**
 * Is this route one of the admin pages? Used to keep the one "Admin" entry in
 * the menus looking selected wherever inside the panel you are.
 *
 * @param {string} routeName
 * @returns {boolean}
 */
export const isAdminPage = routeName => ADMIN_PAGE_NAMES.includes(routeName);
